module.exports = __webpack_public_path__ + "img/insuranceCompanyService.03b67af1.svg";